Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="dynamic-payment-methods__tabs ';
 if (!_.isEmpty(ctx.enabledPaymentMethods) && ctx.enabledPaymentMethods.length > 3) {;
__p += 'dynamic-payment-methods__tabs--vertical';
} else if (ctx.enabledPaymentMethods.length === 1) {;
__p += 'dynamic-payment-methods__tabs--single';
} else {;
__p += 'dynamic-payment-methods__tabs--multiple-' +
((__t = (ctx.enabledPaymentMethods.length)) == null ? '' : __t) +
' ';
};
__p += '">\n    ';
 if (_.isEmpty(ctx.enabledPaymentMethods)) { ;
__p += '\n        <small class="text-danger">' +
((__t = ( ctx.t('No payment methods have been set or enabled, please configure them.') )) == null ? '' : __t) +
'</small>\n    ';
 } else {  ;
__p += '\n        ';
 ctx.enabledPaymentMethods.forEach(method => { ;
__p += '\n            ';
 
                let hasPanel = false;

                if (method.options || method.multiField || method.description) {
                    hasPanel = true;
                }
            ;
__p += '\n            <input type="radio" name="' +
((__t = ( !ctx.builder ? 'data[paymentmethod]' : 'data[paymentmethod]-builder')) == null ? '' : __t) +
'"\n                value="' +
((__t = ( method.key )) == null ? '' : __t) +
'"\n                data-value="' +
((__t = ( method.name )) == null ? '' : __t) +
'"\n                id="' +
((__t = ( `${method.key}-${method.id}` )) == null ? '' : __t) +
'"\n                class="dynamic-payment-methods--hidden"\n                ref="paymentmethod"\n                ';
 if (method.default) { ;
__p += ' checked="checked" ';
 } ;
__p += '\n            >\n            <label id="' +
((__t = ( `${method.key}-label-${method.id}` )) == null ? '' : __t) +
'" for="' +
((__t = ( `${method.key}-${method.id}` )) == null ? '' : __t) +
'"\n                data-methodKey="' +
((__t = (method.key)) == null ? '' : __t) +
'"\n                class="dynamic-payment-methods__tabs-item ' +
((__t = ( `${method.id}-label` )) == null ? '' : __t) +
' ';
 if (hasPanel) { ;
__p += 'has-panel';
 } ;
__p += '"\n                >\n                ';
 if (method.image) { ;
__p += '\n                    <img class="dynamic-payment-methods__tabs-logo" src="' +
((__t = ( method.image )) == null ? '' : __t) +
'" alt="' +
((__t = ( ctx.t(`${method.label} logo`) )) == null ? '' : __t) +
'">\n                ';
 } ;
__p += '\n                ' +
((__t = ( ctx.t(method.label) )) == null ? '' : __t) +
'\n            </label>\n            ';
 if (hasPanel) {;
__p += '\n                <div id="' +
((__t = ( `${method.key}-panel` )) == null ? '' : __t) +
'" class="dynamic-payment-methods__tabs-panel">\n                    ';
 if (method.options && method.options.length > 0) { ;
__p += '\n                        ';
 if (method.displayType === 'select') { ;
__p += '\n                            <div ref="component" class="form-group formio-component formio-component-select">\n                                <select class="form-control" name="data[' +
((__t = ( method.optionsName )) == null ? '' : __t) +
']" ref="' +
((__t = ( method.optionsName )) == null ? '' : __t) +
'">\n                                    ';
 method.options.forEach(option => { ;
__p += '\n                                        <option value="' +
((__t = ( option.value )) == null ? '' : __t) +
'" ';
 if (ctx.currentPaymentMethod && ctx.currentPaymentMethod[method.optionsName] === option.value) { ;
__p += ' selected="true" ';
 } ;
__p += '>\n                                            ' +
((__t = ( ctx.t(option.label) )) == null ? '' : __t) +
'\n                                        </option>\n                                    ';
 }) ;
__p += '\n                                </select>\n                            </div>\n                        ';
 } else { ;
__p += '\n                            <div ref="component" class="form-group formio-component formio-component-radio dynamic-payment-methods__radio">\n                                ';
 method.options.forEach(option => { ;
__p += '\n                                    <div class="dynamic-payment-methods__radio-method">\n                                        <input\n                                            type="radio"\n                                            name="' +
((__t = ( !ctx.builder ? `data[${method.optionsName}]` : `data[${method.optionsName}]builder`)) == null ? '' : __t) +
'"\n                                            value="' +
((__t = ( option.value )) == null ? '' : __t) +
'"\n                                            id="' +
((__t = ( `${method.optionsName}-${option.value}-${method.id}` )) == null ? '' : __t) +
'"\n                                            ref="' +
((__t = ( method.optionsName )) == null ? '' : __t) +
'"\n                                            ';
 if (
                                            ctx.data.dynamicpaymentmethods && method.optionsName in ctx.data.dynamicpaymentmethods && 
                                            ctx.data.dynamicpaymentmethods[method.optionsName] === option.value
                                            ) { ;
__p += '\n                                                checked\n                                            ';
 } ;
__p += '\n                                        >\n                                        <label for="' +
((__t = ( `${method.optionsName}-${option.value}-${method.id}` )) == null ? '' : __t) +
'"  >\n                                            <img class="payment-logo" src="' +
((__t = ( option.image )) == null ? '' : __t) +
'" alt="' +
((__t = ( ctx.t(option.label) )) == null ? '' : __t) +
'">\n                                            <span class="payment-label">' +
((__t = ( ctx.t(option.label) )) == null ? '' : __t) +
'</span>\n                                        </label>\n                                    </div>\n                                ';
 }) ;
__p += '\n                            </div>\n                        ';
 } ;
__p += '\n                    ';
 } ;
__p += '\n                    ';
 if (method.multiField) { ;
__p += '\n                        ';
 method.multiField.forEach(field => { ;
__p += '\n                            <div ref="component" class="form-group formio-component formio-component-textfield formio-component-' +
((__t = ( field.name )) == null ? '' : __t) +
' ';
 if (field.hidden) { ;
__p += ' dynamic-payment-methods--hidden ';
 } ;
__p += '">\n                                ';
 if (field.label) { ;
__p += '\n                                    <label id="' +
((__t = ( `${field.name}-${method.id}` )) == null ? '' : __t) +
'" for="' +
((__t = ( `${field.name}-${method.id}` )) == null ? '' : __t) +
'"\n                                        class="col-form-label ';
 if (field.required) { ;
__p += 'field-required';
 } ;
__p += '" ref="label">\n                                        ' +
((__t = ( ctx.t(field.label) )) == null ? '' : __t) +
'\n                                    </label>\n                                ';
 } ;
__p += '\n                                <input\n                                    id="' +
((__t = ( `${field.name}-${method.id}` )) == null ? '' : __t) +
'"\n                                    name="' +
((__t = ( !ctx.builder ? `data[${field.name}]` : `data[${field.name}]builder` )) == null ? '' : __t) +
'"\n                                    class="js_fancy_input fancy_input form-control gm-fancyinput"\n                                    ref="' +
((__t = ( field.name )) == null ? '' : __t) +
'"\n                                    type="text"\n                                    ';
 if (ctx.data.dynamicpaymentmethods && field.name in ctx.data.dynamicpaymentmethods) { ;
__p += '\n                                        value="' +
((__t = ( ctx.data.dynamicpaymentmethods[field.name] )) == null ? '' : __t) +
'"\n                                    ';
 } ;
__p += '\n                                    placeholder="' +
((__t = ( ctx.t(field.placeholder) )) == null ? '' : __t) +
'">\n                            </div>\n                        ';
 }) ;
__p += '\n                    ';
 } ;
__p += '\n                    ';
 if (method.description) { ;
__p += '\n                        <div ref="component" class="formio-component formio-component-htmlelement formio-component-html">\n                            <p ref="html" class="formio-component-htmlelement paymentmethod-description ' +
((__t = ( `${method.id}-description` )) == null ? '' : __t) +
'">' +
((__t = ( ctx.t(method.description) )) == null ? '' : __t) +
'</p>\n                        </div>\n                    ';
 } ;
__p += '\n                </div>\n            ';
 } ;
__p += '\n        ';
 }) ;
__p += '\n    ';
 } ;
__p += '\n</div>\n';
return __p
}